<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="8">
            <a-form-item label="字典项文本">
              <a-input placeholder="请输入字典项文本" v-model="queryParam.text"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item label="字典项值">
              <a-input placeholder="请输入字典项值" v-model="queryParam.value"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search"></a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"></a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px"></a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectDictItem-modal ref="modalForm" @ok="modalFormOk" :dict="dict"></projectDictItem-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectDictItemModal from './modules/ProjectDictItemModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "ProjectDictItemList",
    mixins:[JeecgListMixin],
    components: {
      ProjectDictItemModal
    },
    props:{
      dict:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data () {
      return {
        description: '项目字典明细管理页面',
        /* 排序参数 */
        isorter:{
          column: 'sortOrder',
          order: 'asc',
        },
        // 表头
        columns: [

          {
            title: '字典项文本',
            align:"center",
            ellipsis: true,
            dataIndex: 'text'
          },
          {
            title: '字典项值',
            align:"center",
            ellipsis: true,
            dataIndex: 'value'
          },

          {
            title: '排序',
            align:"center",
            dataIndex: 'sortOrder'
          },
          {
            title: '描述',
            ellipsis: true,
            align:"center",
            dataIndex: 'description'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/project/projectDictItem/list",
          delete: "/project/projectDictItem/delete",
        },
        disableMixinCreated:true,
      }
    },
    computed: {
    },
    watch:{
      dict(){
        this.baseQueryParam = {
          dictId:this.dict.id
        }
        this.loadData()
      }
    },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>